import { type PostFactiii } from '@shared/all/domains/factiiis';
import { type PostResponse } from '@shared/all/domains/posts';

const groupByFactiiiId = (pages: PostResponse[]) => {
  const groupedMap = new Map<
    number,
    (PostFactiii & {
      user: PostResponse['posts'][0]['user'];
    })[][]
  >();

  pages.forEach((page, i) => {
    const dataFactiiisWithUser = page.posts.flatMap((post) =>
      post.postFactiiisCount?.map((postFactiii) => ({
        ...postFactiii,
        user: post.user
      }))
    );

    dataFactiiisWithUser.forEach((item) => {
      if (!item) return;
      const id = item.factiiiId;

      if (!groupedMap.has(id)) {
        groupedMap.set(id, []);
      }
      const array = groupedMap.get(id);
      if (!array![i]) {
        array!.push([item]);
      } else {
        array![i].push(item);
      }
    });
  });
  const groupedArray: (PostFactiii & {
    user: PostResponse['posts'][0]['user'];
  })[][][] = Array.from(groupedMap.values());
  return groupedArray;
};

export default groupByFactiiiId;
